import Chart from "chart.js/auto";
import { CHART_TOOLTIP, CHART_LEGEND_LABEL, reloadChart } from "../../vendors/chart";
import { cssVar, COLORS } from "../../utils";

const WRAPPER = document.getElementById("chart-doughnut");
let chart;

export const doughnut = () => {
	const DATA = {
		labels: ["Submitted", "Processing", "Awaiting Repair", "Approved", "Completed"],
		datasets: [
			{
				data: [32, 45, 18, 27, 38],
				backgroundColor: [
					"#E7E7E7",  // Submitted
					"#A3A8B2",  // Processing
					"#545E85",  // Awaiting Repair
					"#8d95ca",  // Approved
					"#101B4B"   // Completed
				],
				borderWidth: 3,
				borderColor: "rgba(0, 0, 0, 0.1)",
				hoverOffset: 1,
				hoverBorderWidth: 0,
			},
		],
	};

	// Chart config
	const CONFIG = {
		type: "pie",
		data: DATA,
		options: {
			maintainAspectRatio: false,
			cutout: 75,
			interaction: {
				mode: "index",
				intersect: false,
			},
			responsive: true,
			plugins: {
				legend: {
					position: "bottom",
					labels: {
						usePointStyle: true,
						...CHART_LEGEND_LABEL,
					},
				},
				title: {
					display: false,
				},
				tooltip: {
					...CHART_TOOLTIP,
					callbacks: {
						label: function(context) {
							const label = context.label || '';
							const value = context.raw || 0;
							const total = context.dataset.data.reduce((a, b) => a + b, 0);
							const percentage = Math.round((value / total) * 100);
							return `${label}: ${value} claims (${percentage}%)`;
						}
					}
				},
			},
		},
	};

	// Init chart
	if (WRAPPER) {
		chart = new Chart(WRAPPER, CONFIG);
	}
};

// Reload chart to match dark/light mode when switched
export const doughnutChartUpdate = () => {
	if (WRAPPER) {
		setTimeout(() => {
			reloadChart(chart, (chart.data.datasets[0].borderColor = cssVar("--bs-chart-pie-border-color")));
		});
	}
};